import React, { useState } from "react";
import { FaLocationDot, FaPhone } from "react-icons/fa6";
import { BiSolidUpArrow, BiSolidDownArrow } from "react-icons/bi";
import { TbMailFilled } from "react-icons/tb";
import { Link } from "react-router-dom";

const TopNav = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="  bg-primary-450  text-gray-200 ">
      <div className=" md:w-10/12 mx-auto  md:px-0 px-4">
        <div className="hidden lg:flex justify-between text-sm">
          <div className="flex items-center gap-5">
            <div className="flex items-center gap-3 lg:gap-2">
              <FaLocationDot className=" text-white " />
              Thapagaun, New Baneshwor Kathmandu Nepal
            </div>
            <div className="flex items-center gap-3 lg:gap-2">
              <TbMailFilled className="size-4 text-white" />
              hvtcampus@gmail.com
            </div>
            <div className="flex items-center gap-3 lg:gap-2">
              <FaPhone className="text-white" />
              01-5244745 , 014793874
            </div>
          </div>
          <div className=" flex  justify-center items-center">
            <Link
              to={"/events"}
              className="flex items-center py-3 px-6 bg-green-600 hover:bg-green-500 duration-700 gap-3 text-white"
            >
              EVENTS
            </Link>
            <Link
              to={"/notices"}
              className="flex items-center  hover:bg-red-600 duration-700   text-white bg-red-700 gap-3  py-3 px-6"
            >
              NOTICE
            </Link>
          </div>
        </div>
        <div className="lg:hidden">
          <div
            className={`transition-all duration-700 ${
              isOpen ? "max-h-screen" : "max-h-0"
            } overflow-hidden`}
          >
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-[1.5rem]">
                <FaLocationDot className=" text-white size-5" />
                Thapagaun, New Baneshower Kathmandu Nepal
              </div>
              <div className="flex items-center gap-[1.5rem]">
                <TbMailFilled className="size-5 text-white" />
                hvtcampus@gmail.com
              </div>
              <div className="flex items-center gap-[1.5rem]">
                <FaPhone className=" text-white" />
                01-5244745
              </div>
              <div className=" mt-4">
                {" "}
                गुणस्तरीय प्राविधिक शिक्षाका लागि (HVTC)
              </div>
            </div>
          </div>
          <div className="flex justify-center">
            <button
              onClick={toggleAccordion}
              className="focus:outline-none mt-3"
            >
              {isOpen ? <BiSolidUpArrow /> : <BiSolidDownArrow />}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopNav;
